export default __webpack_public_path__ + "gateway.62409b9baa3819eae36d.svg";